"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const xstate_1 = require("xstate");
const actions = __importStar(require("./actions"));
const constants_1 = require("../common/constants");
const createReferralConnectorMachine = (context) => (0, xstate_1.createMachine)({
    id: 'Machine__Connector',
    initial: constants_1.ReferralStates.initialized,
    context: Object.assign({ referrals: [], maxReferralCount: 10 }, context),
    states: {
        [constants_1.ReferralStates.initialized]: {
            entry: ['onInitialization'],
            always: [
                {
                    target: constants_1.ReferralStates.someReferrals,
                    cond: (ctx) => ctx.referrals.length > 0 &&
                        ctx.referrals.length < ctx.maxReferralCount
                },
                {
                    target: constants_1.ReferralStates.maxReferrals,
                    cond: (ctx) => ctx.referrals.length === ctx.maxReferralCount
                },
                { target: constants_1.ReferralStates.noReferrals }
            ]
        },
        [constants_1.ReferralStates.noReferrals]: {
            on: {
                [constants_1.ReferralEvents.ADD_REFERRAL]: {
                    target: constants_1.ReferralStates.initialized,
                    actions: ['addReferral', 'onAddReferral']
                }
            }
        },
        [constants_1.ReferralStates.someReferrals]: {
            on: {
                [constants_1.ReferralEvents.REMOVE_REFERRAL]: {
                    target: constants_1.ReferralStates.initialized,
                    actions: ['removeReferral', 'onRemoveReferral']
                },
                [constants_1.ReferralEvents.ADD_REFERRAL]: {
                    target: constants_1.ReferralStates.initialized,
                    actions: ['addReferral', 'onAddReferral']
                },
                [constants_1.ReferralEvents.SEND_REFERRAL_DATA]: {
                    target: constants_1.ReferralStates.sendingReferralData,
                    actions: ['onSendReferralData']
                }
            }
        },
        [constants_1.ReferralStates.maxReferrals]: {
            on: {
                [constants_1.ReferralEvents.REMOVE_REFERRAL]: {
                    target: constants_1.ReferralStates.initialized,
                    actions: ['removeReferral', 'onRemoveReferral']
                },
                [constants_1.ReferralEvents.SEND_REFERRAL_DATA]: {
                    target: constants_1.ReferralStates.sendingReferralData,
                    actions: ['onSendReferralData']
                }
            }
        },
        [constants_1.ReferralStates.sendingReferralData]: {
            invoke: {
                id: 'sendReferralData',
                src: 'sendReferralData',
                onDone: {
                    target: constants_1.ReferralStates.initialized,
                    actions: 'clearReferrals'
                },
                onError: {
                    target: constants_1.ReferralStates.sendingReferralDataError,
                    actions: 'setError'
                }
            }
        },
        [constants_1.ReferralStates.sendingReferralDataError]: {}
    }
}, {
    actions,
    services
});
/**
 * Services stub for future use
 */
const services = {
    sendReferralData: () => __awaiter(void 0, void 0, void 0, function* () {
        return Promise.resolve(true);
    })
};
exports.default = createReferralConnectorMachine;
//# sourceMappingURL=machine.js.map